import { BorderGridContainer, GridBox, H2 } from '@ahmdigital/ui';
import { useState } from 'react';

import TrustpilotWidget from '../../../components/trustpilot-widget';
import useIsAfterHydration from '../../../hooks/use-is-after-hydration';
import type { ExternalContent as ExternalContentType } from '../../../types/__codegen__/sanity/graphql';

type ExternalContentProps = ExternalContentType & {
  identifier: 'trustpilot-widget' | string;
};

const ExternalContent = ({ identifier, title }: ExternalContentProps) => {
  const isAfterHydration = useIsAfterHydration();
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  if (identifier === 'trustpilot-widget') {
    return (
      <BorderGridContainer>
        <GridBox padding="5rem">
          {isAfterHydration && title && isWidgetReady && (
            <H2 looksLike="h4" variant={['center', 'marginBottomSpacer8']}>
              {title}
            </H2>
          )}
          {isAfterHydration && <TrustpilotWidget onReady={() => setIsWidgetReady(true)} />}
        </GridBox>
      </BorderGridContainer>
    );
  }
  return null;
};

export default ExternalContent;
